import { render, staticRenderFns } from "./creditos.vue?vue&type=template&id=2a88ff8a&scoped=true"
import script from "./creditos.vue?vue&type=script&lang=js"
export * from "./creditos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a88ff8a",
  null
  
)

export default component.exports